import validate from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@18.19.127_@vue+compiler-sfc@3.5.22_db0@0.3.2_esl_pywiuah62xewji35ldldycfhxe/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/auth.global.ts";
import clubvip_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/clubvip.global.ts";
import containment_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/containment.global.ts";
import coupon_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/coupon.global.ts";
import deposit_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/deposit.global.ts";
import enter_45site_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/enter-site.global.ts";
import game_45mobile_45preview_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/gameMobilePreview.global.ts";
import redirects_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/redirects.global.ts";
import route_45global from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/route.global.ts";
import manifest_45route_45rule from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@18.19.127_@vue+compiler-sfc@3.5.22_db0@0.3.2_esl_pywiuah62xewji35ldldycfhxe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  clubvip_45global,
  containment_45global,
  coupon_45global,
  deposit_45global,
  enter_45site_45global,
  game_45mobile_45preview_45global,
  redirects_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "router-casino": () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/middleware/routerCasino.ts")
}